import { i18next, utils } from '@yola/ws-sdk';

const { isPhoneNumber } = utils.validation;

const createPhoneValidator = () => (value) => {
  if (!value) {
    return i18next.t('Invalid phone number. The phone number can not be empty');
  }

  if (!isPhoneNumber(value.trim())) {
    return i18next.t('Invalid phone number. Please, check the phone number and try again');
  }

  return null;
};

export default createPhoneValidator;
